import {
  CylinderGeometry,
  Mesh,
  MeshBasicMaterial,
  Object3D,
  Scene,
  Vector3,
} from "three";
import { generateUUID } from "three/src/math/MathUtils.js";
import { CameraInterface, Engine } from "../engine/Engine";
import { Label } from "./Label";
import { Point } from "./Point";

export class Corner extends Point {
  private _label?: Label;
  private _scale = 1;
  private readonly _actualScale = 0.05;

  constructor(point: Vector3) {
    super();
    this._type = "Corner";
    this._name = "Corner_" + generateUUID();
    this.point = point;

    Engine.activeEngine.addEventListener("camera-change", (e: any) => {
      if (e.detail.type == "OrthographicCamera") {
        this._scale = (this._actualScale * 50) / e.detail.zoom;
        this._updateScale();
      }
    });
  }

  private _updateJointLines() {}

  private _updateScale() {
    this.root?.scale.set(this._scale, 1, this._scale);
  }

  get root() {
    return this._root;
  }

  set label(value: Label) {
    this._label = value;
  }

  get label(): Label | undefined {
    return this._label;
  }

  private _createCylinder(radius: number, order: number, color?: number) {
    const geometry = new CylinderGeometry(radius, radius, 0.001, 16);
    const material = new MeshBasicMaterial({
      color: color ? color : 0x000000,
      transparent: true,
      opacity: 0.5,
    });
    const mesh = new Mesh(geometry, material);
    mesh.renderOrder = order;
    mesh.material.depthTest = false;
    mesh.material.depthWrite = false;
    return mesh;
  }

  addJoint(point: Point): void {
    super.addJoint(point);
    //const r = this.joints?.filter((e) => e instanceof Wall);
  }

  render2d(scene?: Scene, camera?: CameraInterface): void {
    if (this._root) scene?.remove(this._root);

    if (!this._root) {
      const mesh1 = this._createCylinder(0.1, 100, 0x0000ff);
      const mesh2 = this._createCylinder(0.08, 101, 0xdddddd);

      this._root = new Object3D();
      this._root.name = this._name;
      this._root.add(mesh1);
      this._root.add(mesh2);
    }

    if (camera) {
      const zoom = (camera as any).fov;
      if (zoom) this._scale = (this._actualScale * 50) / zoom;
    }
    this._updateScale();
    this._updateJointLines();

    let point = this.point.clone();

    this._root.position.copy(point);
    if (this._root) scene?.add(this._root);

    if (this._joints!.length > 2) {
    }
  }

  render3d(scene?: Scene, camera?: CameraInterface): void {
    if (this._root) scene?.remove(this._root);
  }

  dispose(scene?: Scene): void {
    super.dispose(scene);
    this._label?.dispose();
    this._root?.removeFromParent();
    this._root?.traverse((m) => {
      if (m instanceof Mesh) m.geometry.dispose();
    });
  }
}
